import styled from 'styled-components';
import {ByocOnboardingContainer} from '../styles';

export const IntegrationStatusContainer = styled(ByocOnboardingContainer)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const SuccessIcon = styled.div`
  margin-top: 32px;
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SuccessTitle = styled.div`
  font-size: 32px;
  font-weight: 700;
  color: #2f3d48;
  margin-bottom: 40px;
  text-align: center;

  @media (max-width: 767px) {
    font-size: 24px;
  }
`;

export const PlatformStatusCard = styled.div`
  width: 100%;
  max-width: 800px;
  background-color: #ffffff;
  box-shadow: 0 8px 16px 0 #dddddd52;
  border-radius: 10px;
  padding: 24px;
  margin-bottom: 20px;
  display: flex;
  align-items: flex-start;
  gap: 24px;

  &:last-child {
    margin-bottom: 0;
  }

  @media (max-width: 767px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;

export const PlatformLogo = styled.div`
  flex-shrink: 0;
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  padding: 16px;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  @media (max-width: 767px) {
    width: 100px;
    height: 100px;
  }

  &.bSize {
    padding: 16px 0;
  }
`;

export const PlatformStatusContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  text-align: left;

  @media (max-width: 767px) {
    text-align: center;
  }
`;

export const StatusRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: space-between;

  @media (max-width: 767px) {
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }

  &.connected {
    align-items: center;
  }
`;

export const StatusLabel = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #2f3d48;
  min-width: 150px;

  @media (max-width: 767px) {
    min-width: auto;
  }
`;

export const StatusValue = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => (props.$isConnected ? '#e8f5e9' : '#ffebee')};
  border-radius: 30px;
  padding: 6px 16px;
  font-size: 14px;
  font-weight: 700;
  color: ${(props) => (props.$isConnected ? '#17c981' : '#f44336')};
  min-width: fit-content;
`;

export const StatusText = styled.div`
  font-size: 14px;
  color: #2f3d48;
  line-height: 1.5;
  flex: 1;
`;
